// TYPES
import { CONFIG_SET_LOADING } from './actions';
// INTITAL STATE
const initialState = { 
    loading: true,
}
// CONFIG REDUCER
export const configReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONFIG_SET_LOADING:
            return {
                ...state,
                loading: !!action.payload,
            };
        case 'DECREMENT':
            return {
                x: state.x + 1
            }
        case 'RESET':
            return {
                x: state.x + 1
            }
        default:
            return state;
    }
}